import FileTreeBrowser from '../file_tree_browser/file_tree_browser.vue?vue3';
import repositoryPathMixin from '~/repository/mixins/repository_path';
import { generateHistoryUrl } from '~/repository/utils/url_utility';
import HeaderArea from './header_area.vue?vue3';
import ForkInfo from './fork_info.vue?vue3';
import LastCommit from './last_commit.vue?vue3';
export default {
    name: 'RepositoryApp',
    components: {
        FileTreeBrowser,
        HeaderArea,
        ForkInfo,
        LastCommit
    },
    mixins: [
        repositoryPathMixin
    ],
    props: {
        projectPath: {
            type: String,
            required: true
        },
        projectId: {
            type: String,
            required: true
        },
        currentRef: {
            type: String,
            required: true
        },
        refType: {
            type: String,
            required: false,
            default: null
        },
        historyLink: {
            type: String,
            required: true
        },
        forkInfo: {
            type: Object,
            required: false,
            default: null
        }
    },
    computed: {
        showFileTreeBrowser () {
            return this.$route.name !== 'projectRoot';
        },
        routeRefType () {
            return this.$route.meta.refType || this.$route.query.ref_type;
        },
        historyUrl () {
            return generateHistoryUrl(this.historyLink, this.computedPath, this.routeRefType).href;
        }
    }
};
